import * as React from 'react';
import {connect} from 'react-redux';
import {withStyles, WithStyles, ListItemIcon, Menu, MenuItem, Dialog, DialogTitle, CircularProgress} from '@material-ui/core';
import IconButton from '@components/common/iconButton/iconButton.component';
import TranslateNew from '@translate/TranslateNew';
import { ChatStyle } from './Chat.style';
import BackIcon from "@material-ui/icons/ArrowBackIos";
import SettingsIcon from '@material-ui/icons/TuneRounded';
import EditIcon from '@material-ui/icons/EditRounded';
import ArchiveIcon from '@material-ui/icons/ArchiveRounded';
import VideoCallIcon from '@material-ui/icons/VideocamRounded';
import CloseIcon from '@material-ui/icons/CloseRounded';
import GenerateIcon from '@material-ui/icons/BrushRounded';
import { ChatType, IChat } from '@app-types/websocket/chat.types';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { DialogTop } from '@components/economy/DialogComponens';
import EditChat from './EditChat';
import { SaveAlt } from '@material-ui/icons';
import { FamilyMemberType } from '@services/family/family.constants';
import { secondaryColor, styleColors } from 'src/main.style';
import { AI_RESULT, AI_TASK_TYPE, IAiTask } from '@app-types/websocket/event.types';
import * as EventActions from '@services/events/event.action';
import { displayErrorMessage } from '@services/user/user.actions';


const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof ChatStyle> {
  userId: number;
  family: IFamilyMember[];
  chatId:number|undefined;
  chats:IChat[];
  isOnline: boolean;
  back: () => void;
  archiveChat:(chatId:number) => void;
  call:(chatId:number) => void;
  downloadChatHistory:() => void;
  // isDownloading: number | undefined;
  chatIconTasks: IAiTask[];
  aiTask: (task:IAiTask) => void;
  displayErrorMessage: (msg: string) => void;
}

interface IState {
  openMenu:boolean,
  openEditChat:boolean;
}

class ChatTopBar extends React.Component<IProps, IState> {
  private menuRef:React.RefObject<HTMLButtonElement>=React.createRef();

  constructor(props: IProps) {
    super(props);
    this.state = {
      openMenu:false,
      openEditChat:false,
    };
  }

  public componentDidUpdate(prevProps:IProps) {
    if (prevProps.chatIconTasks !== this.props.chatIconTasks && this.props.chatId !== undefined) {
      const failed = this.props.chatIconTasks.some((task) => task.refObject === this.props.chatId
        && task.status === AI_RESULT.FAIL
        && prevProps.chatIconTasks.some((prev) => prev.id === task.id && prev.status === AI_RESULT.IN_PROGRESS));
      if (failed) {
        this.props.displayErrorMessage(tn.lang.chatGenerateIconFailed);
      }
    }
  }

  /*
  public componentDidUpdate(prevProps:IProps) {
    if (prevProps.isDownloading !== undefined && this.props.isDownloading === undefined) {
      this.setState({openMenu:false});
    }
  }
*/

  public render() {
    const {classes, chatId, chats, back, family, userId} = this.props;

    let title:string = tn.lang.unknown;
    let subTitle:string = tn.lang.unknown;
    let icon:JSX.Element = <div className={classes.iconSmall} />;
    let isArchived:boolean = false;

    let chat:IChat|undefined;
    let callStatusRows:string[] = [];

    if (chats && chatId) {
      chat = chats.find((c) => c.id === chatId);
      if (chat) {
        if (chat.icon && chat.icon !== "") {
          icon = <div className={classes.iconSmall} >
            <img src={chat.icon} className={classes.imageIcon} />
          </div>;
        }
        title = chat.title;
        isArchived = chat.hidden ? chat.hidden.includes(this.props.userId) : false;
        const participantIds:number[] = [];
        participantIds.push(userId);
        const participants = chat.participants ? chat.participants : {};
        for (const participantIdString of Object.keys(participants)) {
          const participantId:number = Number(participantIdString);
          if (Number.isFinite(participantId) && participantId !== userId && this.shouldShowParticipant(participantId)) {
            participantIds.push(participantId);
          }
        }

        subTitle = tn.familyMemberNames(participantIds, family);
        callStatusRows = this.getCallStatusRows(participantIds, chat.chatType);
        if (chat.chatType && chat.chatType === ChatType.SYSTEM_CHAT) {
          subTitle = subTitle+" & "+tn.lang.support;
        }
      }
    }

    const chatLoaded:boolean = chat !== undefined;
    const generatingIcon:boolean = chatId !== undefined && this.props.chatIconTasks.some((task) => task.refObject === chatId
      && task.status === AI_RESULT.IN_PROGRESS);
    if (generatingIcon) {
      icon = <div className={classes.iconSmall} style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
        <CircularProgress size={20} />
      </div>;
    }
    const callDisabled:boolean = !chatLoaded || this.props.isOnline === false || callStatusRows.length > 0;

    return (
      <div className={classes.chatTopBar}>
        <IconButton onClick={() => {back(); this.setState({openMenu:false})}} style={{marginLeft: '12px'}}>
          <BackIcon style={{fontSize:'30px', fill:styleColors.blackAlpha45}}/>
        </IconButton>
        <div className={classes.chatTopBarHeader} onClick={() => this.setState({openMenu:true})}>
          <div className={classes.chatTopBarIcon}>
            {icon}
          </div>
          <div className={classes.chatTopBarBackBody}>
            <div className={classes.chatTopBarBackTitle} style={isArchived?{textDecoration:'line-through'}:{}}>{title}</div>
            <div className={classes.chatTopBarBackSubtitle}>{subTitle}</div>
          </div>
        </div>
        {!callDisabled && <IconButton
          aria-label={tn.lang.chatCall}
          title={tn.lang.chatCall}
          onClick={() => this.call()}
          style={{marginTop: '2px', marginLeft: '12px', color: secondaryColor}}>
          <VideoCallIcon style={{fontSize:'30px'}}/>
        </IconButton>}
        <IconButton ref={this.menuRef} onClick={() => this.setState({openMenu:true})}
          style={{marginTop: '2px',marginRight: '12px', marginLeft: callDisabled ? '12px' : '4px'}}>
          <SettingsIcon style={{fontSize:'30px', fill:styleColors.blackAlpha45}}/>
        </IconButton>
        <Menu
            anchorEl={this.menuRef.current}
            open={this.state.openMenu}
            anchorReference="anchorEl"
            onClose={() => this.setState({openMenu:false})}
            transformOrigin={{vertical: 'top', horizontal: 'right'}}
            classes={{
            paper: classes.menuPaper,
            list: classes.menuList,
            }}
        >

          {/* Call */}
          <MenuItem
            disabled={callDisabled}
            className={classes.menuListItem}
            onClick={() => {this.call(); this.setState({openMenu: false})}}>
              <ListItemIcon>
                  <VideoCallIcon />
              </ListItemIcon>        
              
              <div className={classes.menuItemTitle} style={{flexDirection:'column', alignItems:'flex-start'}}>
                  <span>{tn.lang.chatCall}</span>
                  {this.props.isOnline
                    ?callStatusRows.length === 0
                      ?undefined
                      :callStatusRows.map((row:string, index:number) => (
                        <span
                          key={`${index}-${row}`}
                          style={{fontSize:'12px', lineHeight:1.3, overflowWrap:'anywhere'}}
                        >
                          {row}
                        </span>
                      ))
                    :<span>{tn.lang.initializing}</span>}
              </div>
          </MenuItem>


          {/* Archive thread */}
          <MenuItem
              disabled={!chatLoaded}
              className={classes.menuListItem}
              onClick={() => {this.archiveChat(); this.setState({openMenu: false})}}>
              <ListItemIcon>
                  <ArchiveIcon />
              </ListItemIcon>        
              
              <div className={classes.menuItemTitle}>
                  {isArchived?tn.lang.chatUnarchive:tn.lang.chatArchive}
              </div>
          </MenuItem>

          {/* edit title and icon */}
          <MenuItem
              disabled={!chatLoaded}
              className={classes.menuListItem}
              onClick={() => {this.setState({openEditChat:!this.state.openEditChat, openMenu: false})}}>
              <ListItemIcon>
                  <EditIcon />
              </ListItemIcon>        
              
              <div className={classes.menuItemTitle}>
                  {tn.lang.chatNameChange}
              </div>
          </MenuItem>
          
          {/* generate an icon from the title and first messages */}
          <MenuItem
              disabled={!chatLoaded || generatingIcon || (chat !== undefined && chat.chatType === ChatType.SYSTEM_CHAT)}
              className={classes.menuListItem}
              onClick={() => {this.generateIcon(); this.setState({openMenu: false})}}>
              <ListItemIcon>
                  <GenerateIcon />
              </ListItemIcon>

              <div className={classes.menuItemTitle}>
                  {generatingIcon ? tn.lang.chatGeneratingIcon : tn.lang.chatGenerateIcon}
              </div>
          </MenuItem>

          <MenuItem
            disabled={!chatLoaded}
            className={classes.menuListItem}
            onClick={() => {this.props.downloadChatHistory(); this.setState({openMenu:false});}}
          >
            <ListItemIcon>
                <SaveAlt/>
            </ListItemIcon>
            <div className={classes.menuItemTitle}>
              {tn.lang.save}
            </div>
          </MenuItem> 
        </Menu>
        <Dialog
          open={ this.state.openEditChat}
          onClose={() => this.setState({openEditChat:false})}
          classes={{paper:this.props.classes.bigDialog}}
        >
          <DialogTop>
            <DialogTitle>{tn.lang.editChat}</DialogTitle>
            <IconButton onClick={() => this.setState({openEditChat:false})}>
              <CloseIcon />
            </IconButton>
          </DialogTop>
          <EditChat 
            chat={chat}
            close={() => this.setState({openEditChat:false})} 
            open={this.state.openEditChat}/>
        </Dialog>
      </div>
    );
  }

  private generateIcon() {
    if (this.props.chatId) {
      this.props.aiTask({
        taskType: AI_TASK_TYPE.CHAT_ICON,
        refObject: this.props.chatId,
      });
    }
  }

  private archiveChat() {
    if (this.props.chatId) {
      this.props.archiveChat(this.props.chatId);
    }
  }

  private shouldShowParticipant(participantId:number): boolean {
    const member = this.props.family.find((familyMember) => familyMember.id === participantId);
    return !!member && (
      member.role === FamilyMemberType.CHILD
      || member.role === FamilyMemberType.PARENT
      || member.role === FamilyMemberType.VIEWER
    );
  }

  private getCallStatusRows = (participantIds:number[], chatType?:ChatType): string[] => {
    const notSignedUpIds:number[] = [];
    const disabledCallIds:number[] = [];

    for (const participantId of participantIds) {
      const member:IFamilyMember|undefined = this.props.family.find((familyMember) => familyMember.id === participantId);
      if (!member) {
        continue;
      }

      if (participantId !== this.props.userId && (!member.lastOnline || member.lastOnline <= 0)) {
        notSignedUpIds.push(participantId);
        continue;
      }

      if (member.allowCalls === false) {
        disabledCallIds.push(participantId);
      }
    }

    const rows:string[] = [];
    if (chatType === ChatType.SYSTEM_CHAT) {
      rows.push(tn.lang.chatCallUnavailableSupport);
    }
    if (notSignedUpIds.length > 0) {
      rows.push(tn.lang.chatCallUnavailableSignup(this.getCallParticipantNames(notSignedUpIds)));
    }
    if (disabledCallIds.length > 0) {
      rows.push(tn.lang.chatCallUnavailableDisabled(this.getCallParticipantNames(disabledCallIds)));
    }
    return rows;
  }

  private getCallParticipantNames = (participantIds:number[]): string => {
    const names:string[] = participantIds.map((participantId:number) => (
      participantId === this.props.userId
        ? tn.lang.youSub
        : tn.familyMemberName(participantId, this.props.family)
    ));

    if (names.length === 0) {
      return tn.lang.noone;
    }
    if (names.length === 1) {
      return names[0];
    }
    if (names.length === 2) {
      return `${names[0]} & ${names[1]}`;
    }
    return `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]}`;
  }

  private call() {
    if (this.props.chatId) {
      this.props.call(this.props.chatId);
    }
  }
}


function mapStateToProps(state: any) {
  const chatIconTasks:IAiTask[] = (state.event.aiTasks ? state.event.aiTasks : [])
    .filter((i: IAiTask) => (i.taskType === AI_TASK_TYPE.CHAT_ICON && i.dismissed !== true));

  return {
    chatIconTasks,
  };
}

const mapDispatchToProps = {
  aiTask: EventActions.aiTask,
  displayErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(ChatStyle)(ChatTopBar));



// WEBPACK FOOTER //
// ./src/components/chat/ChatTopBar.tsx